import Immutable from 'immutable';
import {
  SET_PORTAL_DATA,
  SET_PORTAL_FAQS,
  FINISH_SAVE_PORTAL_FAQS,
  START_SAVE_PORTAL_FAQS,
  SET_PORTAL_PAGE_SECTIONS,
  START_SAVE_PORTAL_PAGE_SECTIONS,
  FINISH_SAVE_PORTAL_PAGE_SECTIONS,
  SET_PORTAL_PAGE_SECTION_TYPES,
  SET_PORTAL_SELLING_POINTS,
  FINISH_SAVE_PORTAL_SELLING_POINTS,
  START_SAVE_PORTAL_SELLING_POINTS,
  SET_PORTAL_COURSE_CATEGORIES,
  SET_PORTAL_FOOTER,
  FINISH_SAVE_PORTAL_FOOTER,
  START_SAVE_PORTAL_FOOTER,
  FINISH_SAVE_PORTAL_MEDIA,
  SET_PORTAL_NAV_BAR_LINKS,
  FINISH_SAVE_PORTAL_LANDING_PAGE,
  FINISH_SAVE_PORTAL_BRANDING,
  SET_PORTAL_QUALIFICATION_PAGE_SECTIONS,
  SET_PORTAL_QUALIFICATION_NAV_BAR_LINKS,
  SET_PORTAL_QUALIFICATION_TEMPLATES,
  FINISH_SAVE_PORTAL_QUALIFICATION_PAGE_SECTIONS,
  START_SAVE_PORTAL_QUALIFICATION_LANDING_PAGE,
  FINISH_SAVE_PORTAL_QUALIFICATION_LANDING_PAGE,
  SET_PORTAL_QUALIFICATIONS,
  START_SAVE_QUALIFICATION,
  FINISH_SAVE_QUALIFICATION,
  FINISH_CREATE_QUALIFICATION,
  DELETE_QUALIFICATION_SUCCESS,
  SET_QUALIFICATION_PRICE_SUMMARY,
  SET_PORTAL_COURSES,
  SET_PORTAL_SETTINGS,
  FETCH_PORTAL_FAQS_START,
  FETCH_PORTAL_FAQS_SUCCESS,
  FETCH_PORTAL_FAQS_FAILURE,
  FETCH_PORTAL_SELLING_POINTS_START,
  FETCH_PORTAL_SELLING_POINTS_SUCCESS,
  FETCH_PORTAL_SELLING_POINTS_FAILURE,
  FETCH_PORTAL_QUALIFICATIONS_START,
  FETCH_PORTAL_QUALIFICATIONS_SUCCESS,
  FETCH_PORTAL_QUALIFICATIONS_FAILURE,
} from './actions';

/**
 * @param {object} state
 * @param {object} action
 * @returns {object}
 */
export function PortalAdmin(state = new Immutable.Map(), action = {}) {
  switch (action.type) {
    case SET_PORTAL_DATA: {
      const portalName = action.portalData.name;
      return state.set(portalName, Immutable.fromJS(action.portalData));
    }
    case FETCH_PORTAL_FAQS_SUCCESS: {
      const faqsData = Immutable.Map({
        faqs: Immutable.fromJS(action.faqs),
        error: null,
        isLoading: false,
        isSaving: false,
      });
      return state.setIn([action.portalName, 'faqs'], faqsData);
    }
    case FETCH_PORTAL_FAQS_FAILURE: {
      const faqsData = Immutable.Map({
        faqs: Immutable.List(),
        error: action.error,
        isLoading: false,
        isSaving: false,
      });
      return state.setIn([action.portalName, 'faqs'], faqsData);
    }
    case SET_PORTAL_FAQS:
    case FINISH_SAVE_PORTAL_FAQS: {
      const faqsData = Immutable.Map({
        faqs: Immutable.fromJS(action.faqs),
        isSaving: false,
      });
      return state.setIn([action.portalName, 'faqs'], faqsData);
    }
    case FETCH_PORTAL_FAQS_START: {
      const faqsData = Immutable.Map({
        faqs: Immutable.List(),
        error: null,
        isLoading: true,
        isSaving: true,
      });
      return state.setIn([action.portalName, 'faqs'], faqsData);
    }
    case START_SAVE_PORTAL_FAQS: {
      const faqsData = Immutable.Map({
        faqs: Immutable.fromJS(action.faqs),
        isSaving: true,
      });
      return state.setIn([action.portalName, 'faqs'], faqsData);
    }
    case SET_PORTAL_FOOTER:
    case FINISH_SAVE_PORTAL_FOOTER: {
      const footerData = Immutable.Map({
        footerLinks: Immutable.fromJS(action.footerData),
        isSaving: false,
      });
      return state.setIn([action.portalName, 'footerData'], footerData);
    }
    case START_SAVE_PORTAL_FOOTER: {
      const footerData = Immutable.Map({
        footerLinks: Immutable.fromJS(action.footerData),
        isSaving: true,
      });
      return state.setIn([action.portalName, 'footerData'], footerData);
    }
    case SET_PORTAL_PAGE_SECTION_TYPES: {
      return state.setIn(
        [action.portalName, 'pageSectionTypes'],
        Immutable.fromJS(action.portalPageSectionTypes)
      );
    }
    case SET_PORTAL_PAGE_SECTIONS:
    case FINISH_SAVE_PORTAL_PAGE_SECTIONS: {
      const pageSectionsData = Immutable.Map({
        pageSections: Immutable.fromJS(action.pageSections),
        isSaving: false,
      });
      return state.setIn([action.portalName, 'pageSections'], pageSectionsData);
    }
    case START_SAVE_PORTAL_PAGE_SECTIONS: {
      const pageSectionsData = Immutable.Map({
        pageSections: Immutable.fromJS(action.pageSections),
        isSaving: true,
      });
      return state.setIn([action.portalName, 'pageSections'], pageSectionsData);
    }
    case SET_PORTAL_COURSE_CATEGORIES: {
      const { categories, portalName } = action;
      return state.setIn(
        [portalName, 'categories'],
        Immutable.fromJS(categories)
      );
    }
    case FETCH_PORTAL_SELLING_POINTS_SUCCESS: {
      const sellingPointsData = Immutable.Map({
        sellingPoints: Immutable.fromJS(action.sellingPoints),
        error: null,
        isLoading: false,
        isSaving: false,
      });
      return state.setIn(
        [action.portalName, 'sellingPointsData'],
        sellingPointsData
      );
    }
    case FETCH_PORTAL_SELLING_POINTS_FAILURE: {
      const sellingPointsData = Immutable.Map({
        sellingPoints: Immutable.List(),
        error: action.error,
        isLoading: false,
        isSaving: false,
      });
      return state.setIn(
        [action.portalName, 'sellingPointsData'],
        sellingPointsData
      );
    }
    case SET_PORTAL_SELLING_POINTS:
    case FINISH_SAVE_PORTAL_SELLING_POINTS: {
      const sellingPointsData = Immutable.Map({
        sellingPoints: Immutable.fromJS(action.sellingPoints),
        isSaving: false,
      });
      return state.setIn(
        [action.portalName, 'sellingPointsData'],
        sellingPointsData
      );
    }
    case FETCH_PORTAL_SELLING_POINTS_START: {
      const sellingPointsData = Immutable.Map({
        sellingPoints: Immutable.List(),
        error: null,
        isLoading: true,
        isSaving: true,
      });
      return state.setIn(
        [action.portalName, 'sellingPointsData'],
        sellingPointsData
      );
    }
    case START_SAVE_PORTAL_SELLING_POINTS: {
      const sellingPointsData = Immutable.Map({
        sellingPoints: Immutable.fromJS(action.sellingPoints),
        isSaving: true,
      });
      return state.setIn(
        [action.portalName, 'sellingPointsData'],
        sellingPointsData
      );
    }
    case FINISH_SAVE_PORTAL_MEDIA: {
      return state.setIn(
        [action.portalName, 'media'],
        Immutable.fromJS(action.media)
      );
    }
    case SET_PORTAL_NAV_BAR_LINKS: {
      return state.setIn(
        [action.portalName, 'navBarLinks'],
        Immutable.fromJS(action.navBarLinks)
      );
    }
    case FINISH_SAVE_PORTAL_LANDING_PAGE: {
      let newState = state;
      const pageSectionsData = Immutable.Map({
        pageSections: Immutable.fromJS(action.result.pageSections),
        isSaving: false,
      });
      newState = newState.setIn(
        [action.portalName, 'pageSections'],
        pageSectionsData
      );
      newState = newState.setIn(
        [action.portalName, 'navBarLinks'],
        Immutable.fromJS(action.result.navBarLinks)
      );
      newState = newState.setIn(
        [action.portalName, 'media'],
        Immutable.fromJS(action.result.media)
      );
      return newState;
    }
    case FINISH_SAVE_PORTAL_BRANDING: {
      let newState = state;
      newState = newState.setIn(
        [action.portalName, 'logoUrl'],
        action.result.logoUrl
      );
      newState = newState.setIn(
        [action.portalName, 'strings'],
        Immutable.fromJS(action.result.strings)
      );
      newState = newState.setIn(
        [action.portalName, 'themeData'],
        Immutable.fromJS(action.result.themeData)
      );
      return newState;
    }
    case SET_PORTAL_QUALIFICATION_NAV_BAR_LINKS: {
      return state.setIn(
        [action.portalName, 'qualificationNavBarLinks'],
        Immutable.fromJS(action.qualificationNavBarLinks)
      );
    }
    case SET_PORTAL_QUALIFICATION_PAGE_SECTIONS:
    case FINISH_SAVE_PORTAL_QUALIFICATION_PAGE_SECTIONS: {
      return state.setIn(
        [action.portalName, 'qualificationPageSections'],
        Immutable.Map({
          pageSections: Immutable.fromJS(action.qualificationPageSections),
          isSaving: false,
        })
      );
    }
    case SET_PORTAL_QUALIFICATION_TEMPLATES: {
      return state.setIn(
        [action.portalName, 'qualificationTemplates'],
        Immutable.fromJS(action.qualificationTemplates)
      );
    }
    case START_SAVE_PORTAL_QUALIFICATION_LANDING_PAGE: {
      let newState = state;
      newState = newState.setIn(
        [action.portalName, 'qualificationNavBarLinks'],
        Immutable.fromJS(action.qualificationNavBarLinks)
      );
      newState = newState.setIn(
        [action.portalName, 'qualificationPageSections'],
        Immutable.Map({
          pageSections: Immutable.fromJS(action.qualificationPageSections),
          isSaving: true,
        })
      );
      newState = newState.setIn(
        [action.portalName, 'qualificationTemplates'],
        Immutable.fromJS(action.qualificationTemplates)
      );
      return newState;
    }
    case FINISH_SAVE_PORTAL_QUALIFICATION_LANDING_PAGE: {
      let newState = state;
      newState = newState.setIn(
        [action.portalName, 'qualificationNavBarLinks'],
        Immutable.fromJS(action.result.qualificationNavBarLinks)
      );
      newState = newState.setIn(
        [action.portalName, 'qualificationPageSections'],
        Immutable.Map({
          pageSections: Immutable.fromJS(
            action.result.qualificationPageSections
          ),
          isSaving: false,
        })
      );
      newState = newState.setIn(
        [action.portalName, 'qualificationTemplates'],
        Immutable.fromJS(action.result.qualificationTemplates)
      );
      return newState;
    }
    case FETCH_PORTAL_QUALIFICATIONS_START: {
      const { portalName } = action;
      let newState = state;
      newState = newState.setIn(
        [portalName, 'qualifications'],
        new Immutable.Map()
      );
      newState = newState.setIn([portalName, 'courses'], new Immutable.Map());
      newState = newState.setIn([portalName, 'isLoading'], true);
      newState = newState.setIn([portalName, 'error'], null);
      return newState;
    }
    case FETCH_PORTAL_QUALIFICATIONS_SUCCESS: {
      const { portalName, qualifications, courses } = action;
      let newState = state;
      let qualificationsMap = new Immutable.Map();
      qualifications.forEach((qualification) => {
        qualificationsMap = qualificationsMap.set(
          qualification.mongo_id,
          Immutable.fromJS(qualification)
        );
      });
      newState = newState.setIn(
        [portalName, 'qualifications'],
        qualificationsMap
      );
      newState = newState.setIn(
        [portalName, 'courses'],
        Immutable.fromJS(courses)
      );
      newState = newState.setIn([portalName, 'isLoading'], false);
      newState = newState.setIn([portalName, 'error'], null);
      return newState;
    }
    case FETCH_PORTAL_QUALIFICATIONS_FAILURE: {
      const { portalName, error } = action;
      let newState = state;
      newState = newState.setIn([portalName, 'isLoading'], false);
      newState = newState.setIn([portalName, 'error'], error);
      return newState;
    }
    case SET_PORTAL_QUALIFICATIONS: {
      let newState = state;
      let qualifications = new Immutable.Map();
      action.qualifications.forEach((qualification) => {
        qualifications = qualifications.set(
          qualification.mongo_id,
          Immutable.fromJS(qualification)
        );
      });
      newState = newState.setIn(
        [action.portalName, 'qualifications'],
        qualifications
      );
      return newState;
    }
    case START_SAVE_QUALIFICATION: {
      let qualifications = state.getIn([action.portalName, 'qualifications']);
      let qualification = Immutable.fromJS(action.qualification);
      qualification = qualification.set('isSaving', true);
      qualifications = qualifications.set(
        qualification.get('mongo_id'),
        qualification
      );
      return state.setIn([action.portalName, 'qualifications'], qualifications);
    }
    case FINISH_SAVE_QUALIFICATION: {
      let qualifications = state.getIn([action.portalName, 'qualifications']);
      let qualification = Immutable.fromJS(action.qualification);
      qualification = qualification.set('isSaving', false);
      qualification = qualification.set('lastUpdated', new Date().getTime());
      qualifications = qualifications.set(
        qualification.get('mongo_id'),
        qualification
      );
      return state.setIn([action.portalName, 'qualifications'], qualifications);
    }
    case FINISH_CREATE_QUALIFICATION: {
      let qualifications = state.getIn([action.portalName, 'qualifications']);
      const qualification = Immutable.fromJS(action.result[0]);
      qualifications = qualifications.set(
        qualification.get('mongo_id'),
        qualification
      );
      return state.setIn([action.portalName, 'qualifications'], qualifications);
    }
    case DELETE_QUALIFICATION_SUCCESS: {
      let qualifications = state.getIn([action.portalName, 'qualifications']);
      qualifications = qualifications.delete(
        action.qualification.get('mongo_id')
      );
      return state.setIn([action.portalName, 'qualifications'], qualifications);
    }
    case SET_QUALIFICATION_PRICE_SUMMARY: {
      const { qualification, summary } = action;
      const keyPath = [
        qualification.get('portal'),
        'qualifications',
        qualification.get('mongo_id'),
      ];
      return state.updateIn(keyPath, (val) => val.merge(summary));
    }
    case SET_PORTAL_COURSES: {
      return state.setIn(
        [action.portalName, 'courses'],
        Immutable.fromJS(action.courses)
      );
    }
    case SET_PORTAL_SETTINGS: {
      return state.updateIn([action.portalName], (portal) =>
        portal.merge(action.settings)
      );
    }
    default: {
      return state;
    }
  }
}
